export default "__VITE_ASSET__C$_EVtOe__"